var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 8.33333H1.75M9.625 15.8333L16.45 15.8333C17.4301 15.8333 17.9201 15.8333 18.2945 15.6517C18.6238 15.4919 18.8915 15.2369 19.0593 14.9233C19.25 14.5668 19.25 14.1001 19.25 13.1667V6.83333C19.25 5.89991 19.25 5.4332 19.0593 5.07668C18.8915 4.76308 18.6238 4.50811 18.2945 4.34832C17.9201 4.16667 17.4301 4.16667 16.45 4.16667H14.875M9.625 15.8333L11.375 17.5M9.625 15.8333L11.375 14.1667M6.125 15.8333H4.55C3.56991 15.8333 3.07986 15.8333 2.70552 15.6517C2.37623 15.4919 2.10852 15.2369 1.94074 14.9233C1.75 14.5668 1.75 14.1001 1.75 13.1667V6.83333C1.75 5.89991 1.75 5.4332 1.94074 5.07668C2.10852 4.76308 2.37623 4.50811 2.70552 4.34832C3.07986 4.16667 3.56991 4.16667 4.55 4.16667H11.375M11.375 4.16667L9.625 5.83333M11.375 4.16667L9.625 2.5",
    stroke: "#656C79",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardRefresh);
export default __webpack_public_path__ + "static/media/credit-card-refresh.45481fa7229fe846e637d8cb1234b9b4.svg";
export { ForwardRef as ReactComponent };